import { render, staticRenderFns } from "./PagePartnerPaymentDownload.vue?vue&type=template&id=f770c2e2"
import script from "./PagePartnerPaymentDownload.vue?vue&type=script&lang=js"
export * from "./PagePartnerPaymentDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports